import React, { useState ,useEffect,useRef} from "react";
import './DynamicForm.css';
import { ButtonsForUpdateTicket, Constants } from "../Utils/Constants.js";
import { sanitize } from "../Messages/Messages.js";

export const DynamicForm = ({ currentIndex,allMessages,fields = [],showDynamicForm, onSubmit,onModify,onSearchUser,lookupOptions,onClearLookup,loadingLookup,formId,hasVisibilityExpression,ticketId,onFieldChange,visibleFieldIds,evaluatingVisibility,onFormDataChange,restoredFormValues,changeticket}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [isUiDisabled,setisUiDiabled]= useState(false);
  const [searchValues, setSearchValues] = useState({});
  const defaultLookupLoaded = useRef({});
  const autoSelectedFields = useRef({});
  const [openMultiSelect, setOpenMultiSelect] = useState({});
  const UiDisabled = allMessages.some((item, index) => index > currentIndex && item?.from === "user");
  const [visibilityReady, setVisibilityReady] = useState(!hasVisibilityExpression);
  const [customFields,setcustomFields] = useState({});
  const FIELD_DESCRIPTION = Constants.FIELD_DESCRIPTIONS

  useEffect(() => {
  onFormDataChange?.(formData);
}, [formData, onFormDataChange]);

useEffect(() => {
  if (
    restoredFormValues &&
    Object.keys(restoredFormValues).length > 0
  ) {
    console.log(
      "Applying restored form values:",
      restoredFormValues
    );
 
    setFormData(restoredFormValues);
    setcustomFields(restoredFormValues)
  }
}, [restoredFormValues]);

  useEffect(() => {
    if (hasVisibilityExpression && visibleFieldIds && Array.isArray(visibleFieldIds) && visibleFieldIds.length > 0) {
      console.log("Visibility API returned", visibleFieldIds.length, "field properties");

      const visibleCount = visibleFieldIds.filter(p => p.visible === true).length;
      const hiddenCount = visibleFieldIds.filter(p => p.visible === false).length;

      console.log(`API says: ${visibleCount} visible, ${hiddenCount} hidden`);
    }
  }, [visibleFieldIds]);

  useEffect(() => {

  fields.forEach((field) => {
    if (field.typeDescription?.includes(FIELD_DESCRIPTION.SYSTEM_LOOKUP) && field.defaultValue && /^\d+$/.test(field.defaultValue) && !defaultLookupLoaded.current[field.id]) {
      defaultLookupLoaded.current[field.id] = true;
      searchContactUsers(field.id, String(field.defaultValue).trim(), field.systemLookupTypeName, field.hasFilter, field.propertyDefinitionType);
    }
  });
}, [fields]);

 useEffect(() => {

  fields.forEach((field) => {
  if (field.typeDescription?.includes(FIELD_DESCRIPTION.SYSTEM_LOOKUP) && field.defaultValue && /^\d+$/.test(field.defaultValue)) {

  Object.entries(lookupOptions || {}).forEach(
    ([fieldId, users]) => {
      if (users?.length > 0 && !autoSelectedFields.current[fieldId]) {
        autoSelectedFields.current[fieldId] = true;
        handleChange(
          { id: Number(fieldId) },
          {
            id: users[0].id,
            shortCode: users[0].shortCode,
            name: users[0].name
          }
        );
        setSearchValues((prev) => ({
          ...prev,
          [fieldId]: users[0].name
        }));
 
        onClearLookup(fieldId);
      }
    });
    }
  })
}, [fields,lookupOptions]);

useEffect(() => {
  if (hasVisibilityExpression && onFieldChange && formId && fields && fields.length > 0 ) {
    setVisibilityReady(false);
    // Use restored values if available.
    // Otherwise use current formData.
    const initialFormData =
      restoredFormValues &&
      Object.keys(restoredFormValues).length > 0
        ? restoredFormValues
        : formData;
 
    console.log("Form data used for initial visibility:", initialFormData);
 
    const customFields = fields
      .filter((f) => {
        const fType = f.typeDescription?.toUpperCase() || "";
 
        return (
          !fType.includes(FIELD_DESCRIPTION.GROUP) &&
          !fType.includes(FIELD_DESCRIPTION.CAPTION) &&
          !f.isRootLevel &&
          !fType.includes(FIELD_DESCRIPTION.SYSTEM_LOOKUP) &&
          !fType.includes(FIELD_DESCRIPTION.CUSTOM_LOOKUP) &&
          !fType.includes(FIELD_DESCRIPTION.LOOKUP)
        );
      })
      .map((f) => {
        const fieldValue = initialFormData[f.id];
        const fType = f.typeDescription?.toUpperCase() || "";
 
        // BOOLEAN
        if (fType.includes(FIELD_DESCRIPTION.BOOLEAN)) {
          return {
            customFieldId: f.id,
            customFieldType: f.type,
            booleanValue: fieldValue === true
          };
        }
 
        // Empty value
        if (
          fieldValue === undefined ||
          fieldValue === null ||
          fieldValue === ""
        ) {
          return null;
        }
 
        const customField = {
          customFieldId: f.id,
          customFieldType: f.type
        };
 
        const options =
          f.lookupValues || f.lookupvalues || [];
 
        // SINGLE SELECT
        if (
          fType.includes(FIELD_DESCRIPTION.SINGLE_SELECT) ||
          fType.includes(FIELD_DESCRIPTION.SINGLESELECT)
        ) {
          const option = options.find(
            (opt) => opt.id === Number(fieldValue)
          );
 
          if (option) {
            customField.singleSelectValue = {
              id: option.id,
              shortCode: option.shortCode
            };
          }
        }
 
        // MULTI SELECT
        else if (
          fType.includes(FIELD_DESCRIPTION.MULTI_SELECT) ||
          fType.includes(FIELD_DESCRIPTION.MULTISELECT)
        ) {
          customField.multiSelectValues = (fieldValue || [])
            .map((selectedId) => {
              const option = options.find(
                (opt) =>
                  Number(opt.id) === Number(selectedId)
              );
 
              if (!option) return null;
 
              return {
                customLookupValueId: option.id
              };
            })
            .filter(Boolean);
        }
 
        // STRING
        else if (
          fType.includes(FIELD_DESCRIPTION.STRING)
        ) {
          customField.stringValue = fieldValue;
        }
 
        return customField;
      })
      .filter(Boolean);
 
    console.log(
      "Initial visibility evaluation customFields:",
      customFields
    );
 
    onFieldChange(
      customFields,
      formId,
      hasVisibilityExpression
    );
  }
}, [
  hasVisibilityExpression,
  formId,
  fields,
  restoredFormValues
]);

useEffect(() => {
  if (hasVisibilityExpression && Array.isArray(visibleFieldIds) && visibleFieldIds.length > 0 ) {
    console.log("Visibility API response received. Form is ready to render.");
 
    setVisibilityReady(true);
  }
}, [
  hasVisibilityExpression,
  visibleFieldIds
]);

 const handleUserSelect = (field, user) => {
 
  handleChange(field, {
    id: user.id,
    shortCode: user.shortCode,
    name: user.name
  });
 
  setSearchValues((prev) => ({
    ...prev,
    [field.id]: user.name
  }));
 
  onClearLookup(field.id);
};

  const searchContactUsers = (fieldId,searchText,systemLookupTypeName,hasFilter,propertyDefinitionType,isIconClick = false) => {
  // For icon clicks or filtered searches, allow empty search text
  if (!isIconClick && !hasFilter && (!searchText || searchText.length < 2)) {
    return;
  }

  // If hasFilter is true, we need to send all current form data
  let customFieldsForFilter = null;
  if (hasFilter && formId) {
    customFieldsForFilter = buildCustomFieldsArray();
  }

  onSearchUser(fieldId, searchText, systemLookupTypeName, hasFilter, customFieldsForFilter, formId, propertyDefinitionType, isIconClick);
};

  // Handle magnifying glass click - fetch all results
  const handleLookupIconClick = (field) => {
    // Build customFields for filter if hasFilter is true
    const customFieldsForFilter = field.hasFilter && formId ? buildCustomFieldsArray() : null;
    
    if(field?.propertyIdentifier === FIELD_DESCRIPTION.ASSIGNED_DEPARTMENT){
     onSearchUser(field.id, "",field?.resource, field.hasFilter, customFieldsForFilter, formId, field.propertyDefinitionType, true);
     return
    }

    // Call backend with empty search text and isIconClick flag
    onSearchUser(field.id, "", field.systemLookupTypeName, field.hasFilter, customFieldsForFilter, formId, field.propertyDefinitionType, true);
  };

  // Build customFields array from current form data (for filtering)
  const buildCustomFieldsArray = () => {
    return fields
      .filter((f) =>!f.typeDescription?.includes(FIELD_DESCRIPTION.GROUP) && !f.typeDescription?.includes(FIELD_DESCRIPTION.CAPTION) && !f.isRootLevel)
      .map(f => {
        const fieldValue = formData[f.id];
        const fType = f.typeDescription?.toUpperCase() || "";

        let customField = {
          customFieldId: f.id,
          customFieldType: f.type
        };

        // Add shortCode if available
        if (f.shortCode) {
          customField.customFieldShortCode = f.shortCode;
        }

        // Add webSharedCustomColumnId if available
        if (f.webSharedCustomColumnId) {
          customField.webSharedCustomColumnId = f.webSharedCustomColumnId;
        }

        const options = f.lookupValues || f.lookupvalues || [];

        if (fType.includes(FIELD_DESCRIPTION.SINGLE_SELECT) || fType.includes(FIELD_DESCRIPTION.SINGLESELECT)) {
          const option = options.find(opt => opt.id === Number(fieldValue));
          if (option) {
            customField.singleSelectValue = { id: option.id };
          } else {
            customField.singleSelectValue = { id: 0 };
          }
        } else if (fType.includes(FIELD_DESCRIPTION.MULTI_SELECT) || fType.includes(FIELD_DESCRIPTION.MULTISELECT)) {
          customField.multiSelectValues = (fieldValue || []).map(selectedId => {
            const option = options.find(opt => Number(opt.id) === Number(selectedId));
            if (!option) return null;
            return { customLookupValueId: option.id };
          }).filter(Boolean);
        } else if (fType.includes(FIELD_DESCRIPTION.BOOLEAN)) {
          customField.booleanValue = fieldValue === true ? true : false;
        } else if (fType.includes(FIELD_DESCRIPTION.STRING) || fType.includes(FIELD_DESCRIPTION.TEXT)) {
          customField.stringValue = fieldValue || "";
        } else if (fType.includes(FIELD_DESCRIPTION.DATE)) {
          customField.dateValue = fieldValue ? new Date(fieldValue).toISOString() : null;
        } else if (fType.includes(FIELD_DESCRIPTION.SYSTEM_LOOKUP)) {
          if (fieldValue?.id) {
            customField.systemLookupValueId = fieldValue.id;
          } else {
            customField.systemLookupValueId = 0;
          }
          if (f.systemLookupTypeName) {
            customField.systemLookupTypeName = f.systemLookupTypeName;
          }
        }

        return customField;
      });
  };
 
  // Handle field value change
  const handleChange = (field, value) => {
    const updatedFormData = {
      ...formData,
      [field.id]: value,
    };

    setFormData(updatedFormData);

    setErrors((prev) => ({
      ...prev,
      [field.id]: "",
    }));

    // Only trigger visibility evaluation for SELECT and BOOLEAN fields
    const fieldType = field.typeDescription?.toUpperCase() || "";
    const isSelectField = fieldType.includes(FIELD_DESCRIPTION.SINGLE_SELECT) || fieldType.includes(FIELD_DESCRIPTION.SINGLESELECT) || fieldType.includes(FIELD_DESCRIPTION.MULTI_SELECT) || fieldType.includes(FIELD_DESCRIPTION.MULTISELECT);
    const isBooleanField = fieldType.includes(FIELD_DESCRIPTION.BOOLEAN);
    // If this form has visibility expressions and the changed field is a SELECT or BOOLEAN field
    if (hasVisibilityExpression && onFieldChange && formId && (isSelectField || isBooleanField)) {
      // Build customFields array from current form data
      // Excluding LOOKUP fields (SYSTEM_LOOKUP, CUSTOM_LOOKUP) from visibility evaluation
      const customFields = fields
        .filter((f) => {
          const fType = f.typeDescription?.toUpperCase() || "";
          return (!fType.includes(FIELD_DESCRIPTION.GROUP) && !fType.includes(FIELD_DESCRIPTION.CAPTION) &&
            !f.isRootLevel &&  // Exclude root-level fields
            !fType.includes(FIELD_DESCRIPTION.SYSTEM_LOOKUP) &&  // Exclude system lookups
            !fType.includes(FIELD_DESCRIPTION.CUSTOM_LOOKUP) &&  // Exclude custom lookups
            !fType.includes(FIELD_DESCRIPTION.LOOKUP)  // Exclude any lookup type
          );
        })
        .map(f => {
          const fieldValue = f.id === field.id ? value : updatedFormData[f.id];
          const fType = f.typeDescription?.toUpperCase() || "";
          
          if (fType.includes(FIELD_DESCRIPTION.BOOLEAN)) {
            return {
              customFieldId: f.id,
              customFieldType: f.type,
              booleanValue: fieldValue === true ? true : false // Explicitly set to true or false
            };
          }

          // For other fields, skip if empty
          if (fieldValue === undefined || fieldValue === null || fieldValue === "") return null;

          let customField = {
            customFieldId: f.id,
            customFieldType: f.type
          };

          const options = f.lookupValues || f.lookupvalues || [];

          if (fType.includes(FIELD_DESCRIPTION.SINGLE_SELECT) || fType.includes(FIELD_DESCRIPTION.SINGLESELECT)) {
            const option = options.find(opt => opt.id === Number(fieldValue));
            if (option) {
              customField.singleSelectValue = {
                id: option.id,
                shortCode: option.shortCode
              };
            }
          } else if (fType.includes(FIELD_DESCRIPTION.MULTI_SELECT) || fType.includes(FIELD_DESCRIPTION.MULTISELECT)) {
            customField.multiSelectValues = (fieldValue || []).map(selectedId => {
              const option = options.find(opt => Number(opt.id) === Number(selectedId));
              if (!option) return null;
              return {
                customLookupValueId: option.id
              };
            }).filter(Boolean);
          } else if (fType.includes(FIELD_DESCRIPTION.STRING)) {
            customField.stringValue = fieldValue;
          }

          return customField;
        })
        .filter(Boolean);

      console.log("Evaluating visibility with customFields:", customFields);
      console.log("Boolean fields in API body:", customFields.filter(f => f.booleanValue !== undefined).map(f => ({
        id: f.customFieldId,
        value: f.booleanValue
      })));

      // Call the visibility evaluation
      onFieldChange(customFields, formId, hasVisibilityExpression);
    }
  };
 
  // Get field label dynamically
  const getFieldLabel = (field) => {
    return (
      (typeof field?.name === "string" && field.name) || field?.name?.attribute?.localisedTextGroup?.values?.[0]?.localisedText || field?.name?.attribute?.stringValue || field?.name?.value || field?.propertyIdentifier || field?.shortCode || "Field");
  };
 
  // Get lookup options dynamically
  const getOptions = (field) => {
    return field.lookupValues || field.lookupvalues || [];
  };

  // Check if field should be visible based on visibility expressions
  const isFieldVisible = (field) => {
    // Groups and Captions are always visible
    if (field.typeDescription?.includes(FIELD_DESCRIPTION.GROUP) || field.typeDescription?.includes(FIELD_DESCRIPTION.CAPTION)) {
      return true;
    }

    // IMPORTANT: If field was originally unavailable=true, ALWAYS hide it
    // Even if visibility API says visible=true
    if (field.unavailable === true) {
      return false;
    }

    // If no visibility expressions, all fields are visible
    if (!hasVisibilityExpression) {
      return true;
    }

    // For forms with visibility expressions:
    // If visibleFieldIds has been set by API response (array of formProperty objects)
    if (visibleFieldIds && Array.isArray(visibleFieldIds) && visibleFieldIds.length > 0) {
      // Find this field in the formProperties response
      const formProperty = visibleFieldIds.find(prop => prop.id === field.id);

      // If field is in the API response, use the API's visible flag
      if (formProperty) {
        return formProperty.visible === true;
      }

      // If field not in API response, hide it
      return false;
    }

    // Show all other fields initially
    return true;
  };
 
  // Validate required fields
  const validateForm = () => {
  let tempErrors = {};

  fields.forEach((field) => {
    // Skip validation for hidden fields
    if (!isFieldVisible(field)) {
      return;
    }

    const value = formData[field.id];

    const fieldLabel = field?.name?.attribute?.localisedTextGroup?.values?.[0]?.localisedText || field?.name?.attribute?.stringValue || field?.name?.value || field?.shortCode || "Field";

    if (field.mandatory === true) {
      if (field.typeDescription?.includes(FIELD_DESCRIPTION.BOOLEAN)) {
        if (value !== true) {
          tempErrors[field.id] = `${fieldLabel} is mandatory`;
        }
        return;
      }

      const isEmpty = value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0);
 
      if (isEmpty) {
        tempErrors[field.id] =
          `${fieldLabel} is mandatory`;
 
        return;
      }
    }
 
    const type = field.typeDescription?.toUpperCase() || field.type?.toUpperCase() || "";

    if (fieldLabel.toLowerCase().includes("model after") && !(type.includes(FIELD_DESCRIPTION.SYSTEM_LOOKUP)) && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(value.trim())) {
        tempErrors[field.id] =
          "Please enter a valid email address";
      }
    }

    if ((type.includes(FIELD_DESCRIPTION.INTEGER) || type.includes(FIELD_DESCRIPTION.NUMBER)) && value
    ) {
      if (!/^-?\d+$/.test(value)) {
        tempErrors[field.id] = `${fieldLabel} Contains invalid value`;
      }
    }

    if (type.includes(FIELD_DESCRIPTION.DECIMAL) && value) {
      if (isNaN(Number(value))) {
        tempErrors[field.id] =
          `${fieldLabel} Contains invalid value`;
      }
    }
    if (field.propertyIdentifier === FIELD_DESCRIPTION.scheduledStartDate && value) {
      const endField = fields.find(
        f => f.propertyIdentifier === FIELD_DESCRIPTION.scheduledEndDate
      );

      const endDate = endField ? formData[endField.id] : null;

      if (endDate && new Date(value) > new Date(endDate)) {
        tempErrors[field.id] =
          `${getFieldLabel(field)} cannot be later than ${getFieldLabel(endField)}`;
      }
    }
  });
  setErrors(tempErrors);
  return Object.keys(tempErrors).length === 0;
};
 
  // Submit Form
  const handleSubmit = () => {
    if (!validateForm()) return;

    // Separate root-level fields from custom fields
    const rootLevelFieldsData = {};
    const customFields = [];

    fields
      .filter((field) => !field.typeDescription?.includes(FIELD_DESCRIPTION.GROUP) && !field.typeDescription?.includes(FIELD_DESCRIPTION.CAPTION))
      .forEach(field => {
        const value = formData[field.id];

        // Root-level fields (like scheduledStartDate)
        if (field.isRootLevel && field.propertyIdentifier) {
          if (value === undefined || value === null || value === "") {
            return; // Skip empty values
          }

          const fieldType = field.typeDescription?.toUpperCase() || field.type?.toUpperCase() || "";

          if (fieldType.includes(FIELD_DESCRIPTION.DATE) || fieldType === FIELD_DESCRIPTION.DATE || fieldType === FIELD_DESCRIPTION.DATETIME) {
            rootLevelFieldsData[field.propertyIdentifier] = new Date(value).toISOString();
          } else if (fieldType.includes(FIELD_DESCRIPTION.BOOLEAN) || fieldType === FIELD_DESCRIPTION.BOOLEAN) {
            rootLevelFieldsData[field.propertyIdentifier] = value;
          } else if (fieldType.includes(FIELD_DESCRIPTION.INTEGER) || fieldType.includes(FIELD_DESCRIPTION.NUMBER) || fieldType === FIELD_DESCRIPTION.INTEGER || fieldType === FIELD_DESCRIPTION.NUMBER) {
            rootLevelFieldsData[field.propertyIdentifier] = Number(value);
          } else {
            rootLevelFieldsData[field.propertyIdentifier] = value;
          }
          return; // Skip adding to customFields
        }

        // Regular custom fields
        let customField = {
          customFieldId: field.id,
          customFieldType: field.type
        };

        const options = field.lookupValues || field.lookupvalues || [];
        const fieldType = field.typeDescription?.toUpperCase() || field.type?.toUpperCase() || "";

        if (field.typeDescription?.includes(FIELD_DESCRIPTION.SINGLE_SELECT) || field.typeDescription?.includes(FIELD_DESCRIPTION.SINGLESELECT)) {
          const option = options.find(opt => opt.id === Number(value));
          if (option) {
            customField.singleSelectValue = {
              id: option.id,
              shortCode: option.shortCode
            };
          }
        } else if (fieldType.includes(FIELD_DESCRIPTION.DATE) || field.type === FIELD_DESCRIPTION.DATE || field.type === FIELD_DESCRIPTION.DATETIME) {
          if (value) {
            customField.dateValue = new Date(value).toISOString();
          }
        } else if (field.typeDescription?.includes(FIELD_DESCRIPTION.BOOLEAN)) {
          customField.booleanValue = value;
        } else if (field.typeDescription?.includes(FIELD_DESCRIPTION.STRING)) {
          customField.stringValue = value;
        } else if (field.typeDescription?.includes(FIELD_DESCRIPTION.MULTI_SELECT) || field.typeDescription?.includes(FIELD_DESCRIPTION.MULTISELECT)) {
          customField.multiSelectValues = (value || []).map(selectedId => {
            const option = options.find(opt => Number(opt.id) === Number(selectedId));
            if (!option) return null;
            return {
              customLookupValueId: option.id
            };
          }).filter(Boolean);
        }

        if (value?.id) {
          customField.systemLookupValueId = value.id;
          customField.systemLookupValueShortCode = value.shortCode;
          customField.systemLookupTypeName = field.systemLookupTypeName;
          customField.customFieldShortCode = field.shortCode;
        }

        customFields.push(customField);
      });

    console.log("Submitting form:", { customFields, rootLevelFields: rootLevelFieldsData });
    setisUiDiabled(true);
    if(changeticket){
    onModify({ customFields: customFields.filter(Boolean), rootLevelFields: rootLevelFieldsData,ticketId:ticketId });
    }
    else {
    onSubmit({ customFields: customFields.filter(Boolean), rootLevelFields: rootLevelFieldsData });
    }
  };
 
  // Render Fields
  return (
    <div className={`dynamic-form-container ${(isUiDisabled || UiDisabled) ? "disabled-ticket" : ""}`} style={{ position: 'relative',display: showDynamicForm ? "block" : "none" }}>

      {/* Visibility Evaluation Loading Overlay */}
      {evaluatingVisibility && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          borderRadius: '8px'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div className="lookup-spinner" style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #1E3A5F',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            <span style={{
              color: '#1E3A5F',
              fontSize: '14px',
              fontWeight: '500'
            }}>Loading...</span>
          </div>
        </div>
      )}

      {visibilityReady && fields.map((field) => {
        // Check if field should be visible
        if (!isFieldVisible(field)) {
          return null;
        }

        const label = getFieldLabel(field);

        const type =
          field.typeDescription?.toUpperCase() || "";

        const options = getOptions(field);
        const isSearchLookup = field?.propertyIdentifier === FIELD_DESCRIPTION.ASSIGNED_DEPARTMENT;

        // GROUP
        if (type.includes(FIELD_DESCRIPTION.GROUP)) {

          const groupTitle = field?.name?.value || field?.name?.attribute?.stringValue || "";
          return (
            <div
              key={field.id}
              className="form-group-header"
            >
              {groupTitle}
            </div>
          );
        }
 
        // CAPTION
        if (type.includes(FIELD_DESCRIPTION.CAPTION)) {
          const captionText = field?.description?.attribute?.stringValue || field?.description?.value || field?.name?.attribute?.stringValue || field?.name?.value || "";
          
          return (
            <div
              key={field.id}
              className="form-caption"
              dangerouslySetInnerHTML={{
                __html: sanitize(captionText)
              }}
            />
          );
        }
 
        // SINGLE SELECT
        if (type.includes(FIELD_DESCRIPTION.SINGLE_SELECT) || type.includes(FIELD_DESCRIPTION.SINGLESELECT)) {
          return (
            <div
              key={field.id}
              className="form-group"
            >
              <label
                htmlFor={`field-${field.id}`}
                className="form-label"
              >
                {label}
 
                {field.mandatory && (
                  <span className="required-star">
                    *
                  </span>
                )}
              </label>
 
              <div className="select-wrapper">
                <select
                  id={`field-${field.id}`}
                  name={`field-${field.id}`}
                  className="dynamic-select"
                  value={formData[field.id] || ""}
                  onChange={(e) =>
                    handleChange(
                      field,
                      e.target.value
                    )
                  }
                >
                  <option value="">
                    Select Option
                  </option>
 
                  {options.map((opt) => (
                    <option
                      key={opt.id}
                      value={opt.id}
                    >
                      {opt?.name?.attribute
                        ?.stringValue ||
                        opt?.name?.value}
                    </option>
                  ))}
                </select>
 
                <span className="select-arrow">
                  ▼
                </span>
              </div>
 
              {errors[field.id] && (
                <div className="field-error">
                  {errors[field.id]}
                </div>
              )}
            </div>
          );
        }
        
        // SYSTEM LOOKUP
        if (type.includes(FIELD_DESCRIPTION.SYSTEM_LOOKUP) || isSearchLookup) {
          return (
            <div key={field.id} className="form-group">

              <label className="form-label">
                {label}
                {field.mandatory && (
                  <span className="required-star">*</span>
                )}
              </label>
              <div className="lookup-search-wrapper">

                <input
                  type="text"
                  className="dynamic-input"
                  placeholder={`Search ${label}`}
                  value={
                    searchValues[field.id] ??
                    formData[field.id]?.name ??
                    ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;

                    setSearchValues((prev) => ({
                      ...prev,
                      [field.id]: value
                    }));
                    if (field?.propertyIdentifier === FIELD_DESCRIPTION.ASSIGNED_DEPARTMENT) {
                    searchContactUsers(field.id,  value, field.resource, field.hasFilter,field.propertyDefinitionType);
                    return
                    }
                    searchContactUsers(field.id, value, field.systemLookupTypeName, field.hasFilter, field.propertyDefinitionType);
                  }}
                />
                {loadingLookup[field.id] && (
                  <div className="lookup-loading">
                    <div className="lookup-spinner"></div>
                    <span>Searching {label}...</span>
                  </div>
                )}

                <i
                  className="bi bi-search lookup-icon clickable"
                  onClick={() => handleLookupIconClick(field)}
                  title="Click to view all results"
                ></i>
              </div>

              {(lookupOptions[field.id] || []).length > 0 && (
                <div className="lookup-results">
                  {lookupOptions[field.id].map((user) => (
                    <div
                      key={user.id}
                      className="lookup-item"
                      onClick={() =>
                        handleUserSelect(
                          field,
                          user
                        )
                      }
                    >
                      {user.name}
                    </div>
                  ))}
                </div>
              )}

              {errors[field.id] && (
                <div className="field-error">
                  {errors[field.id]}
                </div>
              )}

            </div>
          );
        }
 
        // MULTI SELECT
        if (type.includes(FIELD_DESCRIPTION.MULTI_SELECT) || type.includes(FIELD_DESCRIPTION.MULTISELECT)) {

          const selectedValues = formData[field.id] || [];

          const isOpen = openMultiSelect[field.id] || false;

          const selectedLabels = options.filter(opt =>selectedValues.includes(opt.id)).map(opt => opt?.name?.attribute?.stringValue || opt?.name?.value);

          return (
            <div
              key={field.id}
              className="form-group"
            >
              <label className="form-label">
                {label}

                {field.mandatory && (
                  <span className="required-star">
                    *
                  </span>
                )}
              </label>

              <div
                className="multi-select-header"
                onClick={() =>
                  setOpenMultiSelect(prev => ({
                    ...prev,
                    [field.id]: !isOpen
                  }))
                }
              >
                <span>
                  {selectedLabels.length > 0
                    ? selectedLabels.join(", ")
                    : "Select Options"}
                </span>

                <span>
                  {isOpen ? "▲" : "▼"}
                </span>
              </div>

              {isOpen && (
                <div className="multi-select-panel">
                  {options.map(opt => {

                    const checked =
                      selectedValues.includes(
                        opt.id
                      );

                    return (
                      <label
                        key={opt.id}
                        className="multi-option"
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => {

                            let updated;

                            if (checked) {
                              updated =
                                selectedValues.filter(
                                  id =>
                                    id !== opt.id
                                );
                            } else {
                              updated = [
                                ...selectedValues,
                                opt.id
                              ];
                            }

                            handleChange(
                              field,
                              updated
                            );
                          }}
                        />

                        <span>
                          {opt?.name?.attribute
                            ?.stringValue ||
                            opt?.name?.value}
                        </span>
                      </label>
                    );
                  })}
                </div>
              )}

              {errors[field.id] && (
                <div className="field-error">
                  {errors[field.id]}
                </div>
              )}
            </div>
          );
        }
 
        // BOOLEAN
        if (type.includes(FIELD_DESCRIPTION.BOOLEAN)) {
          return (
            <div
              key={field.id}
              className="form-checkbox-container"
            >
              <div className="form-checkbox">
                <input
                  type="checkbox"
                  id={`field-${field.id}`}
                  name={`field-${field.id}`}
                  checked={
                    formData[field.id] || false
                  }
                  onChange={(e) =>
                    handleChange(
                      field,
                      e.target.checked
                    )
                  }
                />

                <label
                  htmlFor={`field-${field.id}`}
                >
                  {label}

                  {field.mandatory && (
                    <span className="required-star">
                      *
                    </span>
                  )}
                </label>
              </div>

              {errors[field.id] && (
                <div className="field-error">
                  {errors[field.id]}
                </div>
              )}
            </div>
          );
        }
 
        // DATE (check both type and typeDescription)
        if (type.includes(FIELD_DESCRIPTION.DATE) || type.includes(FIELD_DESCRIPTION.DATETIME) ||
            type === FIELD_DESCRIPTION.DATE || type === FIELD_DESCRIPTION.DATETIME ||
            field.type === FIELD_DESCRIPTION.DATE || field.type === FIELD_DESCRIPTION.DATETIME) {

          return (
            <div
              key={field.id}
              className="form-group"
            >
              <label
                htmlFor={`field-${field.id}`}
                className="form-label"
              >
                {label}

                {field.mandatory && (
                  <span className="required-star">
                    *
                  </span>
                )}
              </label>

              <input
                type="datetime-local"
                id={`field-${field.id}`}
                name={`field-${field.id}`}
                className="dynamic-input"
                value={formData[field.id] || ""}
                onChange={(e) =>
                  handleChange(field, e.target.value)
                }
              />

              {errors[field.id] && (
                <div className="field-error">
                  {errors[field.id]}
                </div>
              )}
            </div>
          );
        }

        // DEFAULT INPUT
        return (
          <div
            key={field.id}
            className="form-group"
          >
            <label
              htmlFor={`field-${field.id}`}
              className="form-label"
            >
              {label}

              {field.mandatory && (
                <span className="required-star">*</span>
              )}

              {label.toLowerCase().includes("model after") && (
                <div className="field-help-text">
                  {Constants.HELP_TEXT}
                </div>
              )}
            </label>
 
            <input
              id={`field-${field.id}`}
              name={`field-${field.id}`}
              type="text"
              className="dynamic-input"
              value={formData[field.id] || ""}
              onChange={(e) =>
                handleChange(
                  field,
                  e.target.value
                )
              }
            />
            {errors[field.id] && (
              <div className="field-error">
                {errors[field.id]}
              </div>
            )}
          </div>
        );
      })}
        {visibilityReady && (
        <div className="d-flex justify-content-end gap-2 mt-2">
          {ButtonsForUpdateTicket(handleSubmit,"Submit", 4)}
        </div>
        )}
    </div>
  );
};
 
export default DynamicForm;